module.exports = __webpack_public_path__ + "img/index_qy.67872419.png";